export default __webpack_public_path__ + "static/media/Oval.be49599a.png";